var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"flex",staticClass:"middle-ellipsis d-flex flex-nowrap align-items-center"},[_c('div',{ref:"breadcrumb",staticClass:"sized-breadcrumb"},[_vm._v(_vm._s(_vm.breadcrumb))]),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }